<template>
  <div class="site-wrap">
    <podcasts-header/>

    <div
      class="site-blocks-cover overlay"
      style="background-image: url(/images/hero_bg_1.jpg);"
      data-aos="fade"
      data-stellar-background-ratio="0.5">
      <div class="container">
        
        <div class="row align-items-center justify-content-center text-center">
            <div v-show="!latestPodcast"  class="col-md-10" data-aos="fade-up" data-aos-delay="1">
          <h2 class="col-md-10  text-center" data-aos="fade-up" data-aos-delay="400">.NET food for the brain is loading, please wait ...</h2>
          </div>
          
          <div v-if="latestPodcast" class="col-md-8" data-aos="fade-up" data-aos-delay="00">
            <search-bar  />
              <h2
              class="text-white font-weight-light mb-2 display-4"
            >{{ latestPodcast.title }}e</h2>
            <div class="text-white mb-4">
              <span class="text-white-opacity-05">
                <small>By {{ latestPodcast.producerName }} | {{ latestPodcast.publishedDate | formatDate }}</small>
              </span>
            </div>
            <p>
              
              <router-link :to="`/shows/${generateSlug(latestPodcast.id,latestPodcast.title)}`" class="btn btn-primary btn-sm py-3 px-4 small">Read The Transcript</router-link>
            </p>

            <div class="player">
              <audio id="player2" :data-id="latestPodcast.id" preload="none" controls style="max-width: 100%">
                <source
                  :src="latestPodcast.mp3"
                  type="audio/mp3"
                >
              </audio>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="site-section bg-light" id="recentPodcasts">
      <div class="container">
        <div class="row mb-5" data-aos="fade-up">
          <div class="col-md-12 text-center">

            <h2 v-show="podcasts == null" class="font-weight-bold text-black">Loading podcasts ...</h2>
            <h2 v-show="podcasts &&  podcasts.length == 0" class="font-weight-bold text-black">No Podcasts found</h2>
            <h2 v-show="podcasts && podcasts.length > 0" class="font-weight-bold text-black">Recent Podcasts</h2>

          </div>
        </div>

        <div
          v-show="podcasts"
          v-for="show in podcasts"
          :key="show.id"
          class="d-block d-md-flex podcast-entry bg-white mb-5"
          data-aos="fade-up"
        >
          <div class="image" :style="{'background-image': 'url(' + randomPic(show.producerImageUrl) + ')'}"></div>
          <div class="text">
            <h3 class="font-weight-light">
              <router-link :to="`/shows/${generateSlug(show.id,show.title)}`">{{show.title}}</router-link>
             
            </h3>
            <div class="text-white mb-3">
              <span class="text-black-opacity-05">
                <small>
                  By {{show.producerName}}
                  <span class="sep">/</span>
                  {{show.publishedDate | formatDate}}
                </small>
              </span>
            </div>

            <div class="player">
              <audio id="player2" :data-id="show.id" preload="none" controls style="max-width:100%">
                <source :src="show.mp3" type="audio/mp3">
              </audio>
            </div>
          </div>
        </div>
      </div>

      <div v-show="podcasts && podcasts.length > 0" class="container" data-aos="fade-up">
        <div class="row">
          <div class="col-md-12 text-center text-white ">
            <a v-show="!first" class="btn btn-primary btn-sm py-3 px-4 mr-5 small" @click.prevent="loadPrev" >Prev page</a>
            <a v-show="!last" class="btn btn-primary btn-sm py-3 px-4 small" @click.prevent="loadNext" >Next page</a>
            
            <!-- <div class="site-block-27">
              <ul class="text-center">
                <li v-show="!first">
                  
                  <a class="btn btn-primary btn-sm py-3 px-4 small" @click.prevent="loadPrev"  href="#"><<<</a>
                </li>
                  ....
                <li v-show="!last">
                  <a @click.prevent="loadNext" href="#">>>></a>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="site-section">
      <div class="container" data-aos="fade-up">
        <div class="row mb-5">
          <div class="col-md-12 text-center">
            <h2 class="font-weight-bold text-black">Most played podcasts</h2>
          </div>
        </div>
        
        <div class="row">
          <div v-for="show in mostPlayed" :key="show.id" class="col-md-6 col-lg-4 mb-5 mb-lg-5">
            <div class="team-member">

              <img :src="randomPic(show.producerImageUrl)" alt="Image" class="img-fluid">

              <div class="text">

                <h2 class="mb-2 font-weight-light h4">{{ show.producerName }}</h2>
                <span class="d-block mb-2 text-white-opacity-05"></span>
                <p class="mb-4">{{ show.title }}</p>
                <p>
                  <router-link :to="`/shows/${generateSlug(show.id,latestPodcast.title)}`" class="btn btn-primary btn-sm py-3 px-4 small">Go to show</router-link>
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>


   
    
    <PodcastsFooter/>
  </div>
</template>

<script>
import PodcastsFooter from "./PodcastsFooter";
import PodcastsHeader from "./PodcastsHeader";
import SearchBar from "@/components/SearchBar.vue";
 
function addPlayEvent(el) {
  console.log('playing')
  let id = el.target.getAttribute("data-id");
  let url = `/api/shows/${id}/play`;
  el.target.removeEventListener('playing',addPlayEvent);
  fetch(url,{method:"POST"});
}

export default {
  name: "podcasts",
  components: {SearchBar, PodcastsFooter, PodcastsHeader },
  
  data() {
    return { latestPodcast:null, podcasts: null, first: false, last: false, currentPage :1, q:'', mostPlayed:[] };
  },
  methods: {
    randomPic: function(img) {
      if (img) return img;
      let pic = "images/img_" + (Math.round(Math.random() * 4) + 1) + ".jpg";
      pic ="/images/tsodn.jpeg";
      return pic;
    },
     generateSlug: function(id, title) {
        const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
        return `${id}-${slug}`;
      },
   async loadPodcasts(){
     this.podcasts = null;
     
     let url = `/api/showslist?page=${this.currentPage}`;
      if (this.q) url +=`&q=${this.q}`
      const resp = await fetch(url);
      const json = await resp.json();
      this.podcasts =  json.shows.filter(p =>{
        if (!this.latestPodcast) return true;
        return p.id != this.latestPodcast.id;
      });
      this.scrollToTop();
      
      this.last= json.last;
      this.first = json.first;
     
     let that = this;
     setTimeout(this.setMediaelements, 2);
    },
    async loadLatestPodcast(){
      const resp = await fetch(`/api/latest`);
      const json = await resp.json();
      this.latestPodcast =  json;
      await this.setMediaelements();
    },
    async loadMostPLayedPodcasts(){
      const resp = await fetch(`/api/mostplayedshows`);
      const json = await resp.json();
      this.mostPlayed =  json;      
    },
    scrollToTop() {      
      if (!this.q &&  (!this.currentPage || this.currentPage < 2) ) return;
      let element = document.getElementById("recentPodcasts");
      element.scrollIntoView();
      // window.scrollTo(0, 0);
    },
    async loadNext(){
      if (!this.last)
      
      this.loadPage(++this.currentPage);

    },
    async loadPrev(){
          if (!this.first)
            this.loadPage(--this.currentPage);
    },
    loadPage(p){
      let url = `/page/${p}`;
      if (this.q) url+=`?search=${this.q}`
      this.$router.push(url)
    },
    
    setMediaelements()     {
      let mediaElements = document.querySelectorAll("video, audio"),
          total = mediaElements.length;

      for (let i = 0; i < total; i++) {
        mediaElements[i].removeEventListener('playing',addPlayEvent)
        mediaElements[i].addEventListener('playing', addPlayEvent, false);
        new MediaElementPlayer(mediaElements[i], {
          pluginPath: "https://cdn.jsdelivr.net/npm/mediaelement@4.2.7/build/",
          shimScriptAccess: "always",
          success: function() {
            const target = document.body.querySelectorAll(".player"),
                targetTotal = target.length;
            for (let j = 0; j < targetTotal; j++) {
              target[j].style.visibility = "visible";
            }
          }
        });
      }
    }
  },
  

 async mounted() {
    this.currentPage =  this.$route.params.p || 1;
    this.q = this.$route.query.search || '';
    await this.loadLatestPodcast();
    await this.loadPodcasts();
    await this.loadMostPLayedPodcasts();

    this.setMediaelements();
  },
  watch: {
    async $route(to, from) {
      this.currentPage = to.params.p;
      if (to.query && to.query.search) {        
        this.q = to.query.search;
        console.log("searching for:", this.q)
      }else this.q = undefined
      await this.loadPodcasts();
       this.setMediaelements();
    }
  },
  // beforeRouteUpdate: function(to, from, next) {
  //   console.log("Before route update page:",to.params.p)
  //   this.q = to.query.search || "";
  //   this.currentPage = to.params.p || 1;
  //   this.loadPodcasts();
  //
  //   next();
  //
  // },

};
</script>

<style scoped>
.site-blocks-cover .player{
  bottom: -200px;
}
</style>

